import Container from 'quarks/Container';

const HorizontalRule = () => (
  <Container as="hr" height="0px" width="100%" borderTop="1px solid" borderColor="gray-300" />
);

export default HorizontalRule;
